export enum MavMessage {
    HEARTBEAT = 0,
    SYS_STATUS = 1,
    GPS_RAW_INT = 24,
    ATTITUDE = 30,
    PARAM_VALUE = 22,
    BATTERY_STATUS = 147,
    VFR_HUD = 74
}